import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Thu Nov 01 2018
 * @author BPo
 */


import { Utils } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { CONSTANTS } from '../../constants';
import logger from '../logger';
/**
 * The class allows periodic check of the endpoint. The logic of
 * this component is universal. So, it is up to you to decide whether
 * polling is no longer necessary and to stop/clear interval.
 */

export var Polling =
/*#__PURE__*/
function () {
  /**
   * @param interval The time, in milliseconds (thousandths of a second), the timer should
   * delay in between executions of the specified function or code.
   */
  function Polling() {
    var _this = this;

    var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CONSTANTS.POLLING_INTERVAL_IN_MS;

    _classCallCheck(this, Polling);

    this.interval = interval;
    this.state = {
      attempts: 0,
      isPolling: false,
      response: undefined,
      error: undefined
    };
    /**
     * It invokes the endpoint and evaluates its status.
     */

    this.enqueue = function () {
      if (Utils.isValueMissing(_this.fetchPromise)) {
        logger.error('[Polling] Fetch promise is missing');
        return;
      }

      _this.fetchPromise().then(function (response) {
        if (_this.onPollResponse) {
          _this.onPollResponse(undefined, response);
        }

        runInAction(function () {
          _this.state.response = response;
          _this.state.error = undefined;
        });
      }).catch(function (error) {
        if (_this.onPollResponse) {
          _this.onPollResponse(error);
        }

        runInAction(function () {
          _this.state.error = error;
          _this.state.response = undefined;
        });
      });

      _this.state.attempts += 1;
    };
  }
  /** True when polling is enabled, false otherwise */


  _createClass(Polling, [{
    key: "startPolling",

    /**
     * Starts the polling if not already stopped
     * @param fetchPromise A function that returns promise. We ask repeatedly, so you must
     * encapsulate promise to functions.
     * @param onPollResponse It will be called when there is a successful (or error) response.
     */
    value: function startPolling(fetchPromise, onPollResponse) {
      this.fetchPromise = fetchPromise;
      this.onPollResponse = onPollResponse;

      if (!this.isPolling) {
        this.enqueue();
        this.intervalRef = window.setInterval(this.enqueue, this.interval);
        this.state.isPolling = true;
        logger.info('[Polling] Started');
      } else {
        logger.warn('[Polling] Running already');
      }
    }
    /**
     * Stops the polling if not already stopped
     */

  }, {
    key: "stopPolling",
    value: function stopPolling() {
      if (this.isPolling) {
        window.clearInterval(this.intervalRef);
        this.state.isPolling = false;
        logger.info('[Polling] Stopped');
      } else {
        logger.warn('[Polling] Stopped already');
      }
    }
    /**
     * Turns off server polling and clears the attempts counter.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.stopPolling();
      this.state.attempts = 0;
    }
  }, {
    key: "isPolling",
    get: function get() {
      return this.state.isPolling;
    }
    /** Number of attempts to call the endpoint. */

  }, {
    key: "attempts",
    get: function get() {
      return this.state.attempts;
    }
  }]);

  return Polling;
}();

__decorate([observable, __metadata("design:type", Object)], Polling.prototype, "state", void 0);

__decorate([action, __metadata("design:type", Object)], Polling.prototype, "enqueue", void 0);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [Function, Function]), __metadata("design:returntype", void 0)], Polling.prototype, "startPolling", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], Polling.prototype, "stopPolling", null);